(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fanaze-editorial-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fanaze-editorial-faq')) {
    customElements.define('fanaze-editorial-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
        document.addEventListener('shopify:block:select', (event) => {
          const item = Array.from(this.querySelectorAll('[data-faq-block]')).find(
            (block) => block.dataset.faqBlock === event.detail?.blockId
          );
          if (!item) return;
          if (this.tabs.length > 1) this.activate(this.panels.indexOf(item.closest('[data-faq-panel]')));
          item.open = true;
        }, { signal });
        if (this.tabs.length < 2) return;
        this.setAttribute('data-enhanced', '');
        this.querySelector('[role="tablist"]').hidden = false;
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.tabIndex = 0;
        });
        this.activate(0);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index), { signal });
          tab.addEventListener('keydown', (event) => {
            let next = index;
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            if (event.key === 'ArrowRight') next += direction;
            else if (event.key === 'ArrowLeft') next -= direction;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.activate(next);
            this.tabs[next].focus();
          }, { signal });
        });
      }

      activate(index) {
        this.tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[current].hidden = !selected;
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanaze-editorial-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-film')) {
    customElements.define('editorial-film', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.attempt = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.playButton = this.querySelector('.editorial-film__play');
        this.fullscreenButton = this.querySelector('.editorial-film__fullscreen');
        this.status = this.querySelector('[role="status"]');
        this.playButton.addEventListener('click', () => this.start(), options);
        this.fullscreenButton.addEventListener('click', () => this.start(true), options);
        // Prepare the short clip near the viewport, without slowing the first screen.
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.prepare();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      }

      prepare() {
        if (this.video) return;
        this.observer?.disconnect();
        this.append(this.querySelector('template').content.cloneNode(true));
        this.video = this.querySelector('video');
        const options = { signal: this.events.signal };
        this.video.addEventListener('playing', () => {
          this.video.inert = false;
          this.setAttribute('data-started', '');
          this.removeAttribute('aria-busy');
          this.status.textContent = '';
          this.playButton.disabled = false;
        }, options);
        this.video.addEventListener('ended', () => {
          if (document.fullscreenElement !== this.video && !this.video.webkitDisplayingFullscreen) this.restoreCover();
        }, options);
        this.video.addEventListener('fullscreenchange', () => {
          if (!document.fullscreenElement && this.video.ended) this.restoreCover();
        }, options);
        this.video.addEventListener('webkitendfullscreen', () => {
          if (this.video.ended) this.restoreCover();
        }, options);
        const loadError = () => {
          this.loadFailed = true;
          if (this.getAttribute('aria-busy') === 'true' || this.hasAttribute('data-started')) this.failed();
        };
        this.video.addEventListener('error', loadError, options);
        this.video.querySelector('source').addEventListener('error', loadError, options);
        this.video.preload = navigator.connection?.saveData ? 'metadata' : 'auto';
        this.video.load();
      }

      async start(fullscreen = false) {
        if (this.getAttribute('aria-busy') === 'true') return;
        this.prepare();
        const attempt = ++this.attempt;
        const retry = this.video.error || this.loadFailed;
        this.status.textContent = '';
        this.setAttribute('aria-busy', 'true');
        this.playButton.disabled = true;
        if (retry) {
          this.loadFailed = false;
          this.video.load();
        }
        if (this.video.ended) this.video.currentTime = 0;
        try {
          const playback = this.video.play();
          if (fullscreen) {
            if (this.video.requestFullscreen) this.video.requestFullscreen().catch(() => {});
          }
          await playback;
          if (!this.isConnected || attempt !== this.attempt) return;
          if (fullscreen && !this.video.requestFullscreen && this.video.webkitEnterFullscreen) {
            try { this.video.webkitEnterFullscreen(); } catch { /* Native controls remain available. */ }
          }
          this.video.focus({ preventScroll: true });
        } catch (error) {
          if (!this.isConnected || attempt !== this.attempt) return;
          if (error.name !== 'AbortError') this.failed();
        } finally {
          if (attempt === this.attempt) {
            this.removeAttribute('aria-busy');
            this.playButton.disabled = false;
          }
        }
      }

      restoreCover() {
        const wasFocused = document.activeElement === this.video;
        this.removeAttribute('data-started');
        this.video.inert = true;
        if (wasFocused) this.playButton.focus({ preventScroll: true });
      }

      failed() {
        this.restoreCover();
        this.removeAttribute('aria-busy');
        this.playButton.disabled = false;
        this.status.textContent = this.dataset.error;
      }

      disconnectedCallback() {
        this.attempt++;
        this.events?.abort();
        this.events = null;
        this.loadFailed = false;
        this.observer?.disconnect();
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          this.video.load();
          this.video.remove();
          this.video = null;
        }
        this.removeAttribute('data-started');
        this.removeAttribute('aria-busy');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanaze-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-winter-photos')) {
    customElements.define('editorial-winter-photos', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.editorial-winter__photo')];
        this.toggle = this.querySelector('.editorial-winter__toggle');
        if (this.slides.length !== 2 || !this.toggle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.dataset.slideshowReady = '';
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        }, options);
        this.mobile.addEventListener('change', this.sync, options);
        this.reduced.addEventListener('change', () => {
          this.paused = this.reduced.matches;
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', this.schedule, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', (event) => {
          this.focused = event.target.closest('.editorial-winter__photo') !== null;
          this.schedule();
        }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = !!event.relatedTarget?.closest('.editorial-winter__photo');
          this.schedule();
        }, options);
        this.slides.forEach((slide) => slide.querySelector('img').addEventListener('load', this.schedule, options));
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);
        this.sync();
      }

      sync = () => {
        this.slides.forEach((slide, index) => {
          const active = !this.mobile.matches || index === this.index;
          slide.toggleAttribute('data-active', active);
          slide.inert = !active;
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        const label = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.title = label;
        this.toggle.toggleAttribute('data-paused', this.paused);
        this.schedule();
      };

      schedule = () => {
        clearTimeout(this.timer);
        if (!this.mobile.matches || this.paused || this.hovered || this.focused || !this.visible || document.hidden) return;
        const ready = this.slides.every((slide) => {
          const image = slide.querySelector('img');
          return image.complete && image.naturalWidth > 0;
        });
        if (!ready) return;
        this.timer = setTimeout(() => {
          this.index = (this.index + 1) % this.slides.length;
          this.sync();
        }, 2000);
      };

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  if (!customElements.get('editorial-home-search')) {
    customElements.define('editorial-home-search', class extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.editorial-cover__search-toggle');
        this.searchForm = this.querySelector('form');
        this.searchInput = this.querySelector('input[type="search"]');
        if (!this.toggleButton || !this.searchForm) return;
        this.toggleButton.addEventListener('click', this.toggleSearch);
        this.addEventListener('keydown', this.closeOnEscape);
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.toggleSearch);
        this.removeEventListener('keydown', this.closeOnEscape);
      }

      toggleSearch = () => {
        const expanded = this.searchForm.hidden;
        this.searchForm.hidden = !expanded;
        this.toggleButton.setAttribute('aria-expanded', String(expanded));
        if (expanded) this.searchInput.focus();
      };

      closeOnEscape = (event) => {
        if (event.key !== 'Escape' || this.searchForm.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        this.toggleSearch();
        this.toggleButton.focus();
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanaze-editorial-pairing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fanaze-editorial-pairing')) {
    customElements.define('fanaze-editorial-pairing', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const choices = [...this.querySelectorAll('[data-choice]')];
        const selectChoice = choice => {
          choices.forEach(item => {
            const selected = item === choice;
            item.dataset.selected = String(selected);
          });
          this.querySelector('[data-pairing-price]').textContent = choice.dataset.price;
          this.querySelector('[data-pairing-compare]').hidden = !choice.dataset.compare;
          this.querySelector('[data-pairing-compare-value]').textContent = choice.dataset.compare;
          this.querySelector('[data-pairing-shop]').href = choice.href;
          this.querySelector('[data-pairing-cta]').textContent = choice.dataset.cta;
        };
        this.querySelectorAll('[data-colour-card]').forEach(card => {
          const choice = card.querySelector('[data-choice]');
          const nativeForm = card.querySelector('product-form-component');
          const form = nativeForm.querySelector('form');
          const size = card.querySelector('[data-pairing-size]');
          const button = card.querySelector('[name="add"]');
          const label = card.querySelector('[data-pairing-add-label]');
          const status = card.querySelector('[data-pairing-status]');
          const bagLink = card.querySelector('[data-pairing-bag]');
          let pending = false, unconfirmed = false, addedVariant = null;
          const render = () => {
            const added = addedVariant && addedVariant === size.value;
            button.disabled = pending || unconfirmed || ![...size.options].some(option => option.value && !option.disabled);
            button.setAttribute('aria-busy', String(pending));
            button.dataset.state = pending ? 'adding' : added ? 'added' : 'idle';
            label.textContent = pending ? this.dataset.addingLabel : added ? this.dataset.addedLabel : this.dataset.addLabel;
          };
          size.addEventListener('change', () => {
            const option = size.selectedOptions[0];
            if (!option?.value || option.disabled) return;
            choice.href = option.dataset.url;
            choice.dataset.price = option.dataset.price;
            choice.dataset.compare = option.dataset.compare;
            form.querySelector('[name="quantity"]').value = option.dataset.minimum;
            nativeForm.dataset.quantityDefault = option.dataset.minimum;
            if (!unconfirmed) {
              card.querySelector('[ref="addToCartTextError"]').classList.add('hidden');
              status.hidden = true;
            }
            selectChoice(choice);
            render();
          }, { signal });
          form.addEventListener('submit', event => {
            if (!pending && !unconfirmed) return;
            event.preventDefault();
            event.stopPropagation();
          }, { signal, capture: true });
          nativeForm.addEventListener('shopify:cart:lines-update', async event => {
            if (event.target !== nativeForm || event.action !== 'add' || !event.promise || pending) return;
            const variantId = size.value;
            pending = true;
            addedVariant = null;
            size.disabled = true;
            status.hidden = true;
            render();
            try {
              const { detail } = await event.promise;
              if (signal.aborted) return;
              if (detail?.didError === false && detail.sourceId === nativeForm.id) addedVariant = variantId;
            } catch {
              if (signal.aborted) return;
              unconfirmed = true;
              status.textContent = this.dataset.uncertainLabel;
              status.hidden = false;
              bagLink.hidden = false;
            } finally {
              if (!signal.aborted) {
                pending = false;
                size.disabled = false;
                render();
              }
            }
          }, { signal });
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanaze-editorial-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fanaze-editorial-reviews')) {
    customElements.define('fanaze-editorial-reviews', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const rows = [...this.querySelectorAll('.er__row')];
        const toggle = this.querySelector('.er__toggle');
        const controls = this.querySelector('.er__controls');
        const widths = new Map();
        let dragging = null;
        const pause = paused => {
          this.classList.toggle('is-paused', paused);
          toggle.setAttribute('aria-pressed', String(paused));
          const label = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
          toggle.querySelector('[data-review-toggle-label]').textContent = label;
          toggle.title = label;
        };
        const mode = () => {
          const isStatic = reducedMotion.matches || this.dataset.autoplay !== 'true';
          this.classList.toggle('is-static', isStatic);
          controls.hidden = isStatic;
          for (const row of rows) row.scrollLeft = isStatic ? 0 : widths.get(row) || 0;
        };
        const resumeSoon = () => {
          clearTimeout(this.resumeTimer);
          this.resumeTimer = setTimeout(() => this.classList.remove('is-interacting'), 1200);
        };
        toggle.addEventListener('click', () => pause(!this.classList.contains('is-paused')), options);
        this.resizeObserver = new ResizeObserver(entries => {
          for (const entry of entries) {
            const row = entry.target.closest('.er__row');
            const width = entry.target.getBoundingClientRect().width;
            if (widths.get(row) === width) continue;
            widths.set(row, width);
            if (!this.classList.contains('is-static')) row.scrollLeft = width;
          }
        });
        for (const row of rows) {
          this.resizeObserver.observe(row.querySelector('.er__set'));
          row.addEventListener('pointerdown', event => {
            clearTimeout(this.resumeTimer);
            this.classList.add('is-interacting');
            if (event.pointerType === 'mouse' && event.button === 0) {
              dragging = { row, id: event.pointerId, x: event.clientX, scroll: row.scrollLeft };
              row.setPointerCapture(event.pointerId);
            }
          }, options);
          row.addEventListener('pointermove', event => {
            if (!dragging || dragging.id !== event.pointerId) return;
            event.preventDefault();
            row.scrollLeft = dragging.scroll + dragging.x - event.clientX;
          }, options);
          const release = event => {
            if (dragging?.id === event.pointerId) {
              row.releasePointerCapture(event.pointerId);
              dragging = null;
            }
            resumeSoon();
          };
          row.addEventListener('pointerup', release, options);
          row.addEventListener('pointercancel', release, options);
          row.addEventListener('scroll', () => {
            if (this.classList.contains('is-static')) return;
            const width = widths.get(row);
            if (width > 0 && (row.scrollLeft < width * .45 || row.scrollLeft > width * 1.55)) {
              const shift = row.scrollLeft < width * .45 ? width : -width;
              row.scrollLeft += shift;
              if (dragging?.row === row) dragging.scroll += shift;
            }
            this.classList.add('is-interacting');
            resumeSoon();
          }, { ...options, passive: true });
          row.addEventListener('keydown', event => {
            if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) pause(true);
          }, options);
        }
        this.classList.add('is-enhanced');
        this.observer = new IntersectionObserver(entries => {
          this.classList.toggle('is-visible', entries[0].isIntersecting);
        }, { rootMargin: '100px' });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.classList.toggle('is-tab-hidden', document.hidden), options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          pause(true);
          const card = event.target.closest('.er__card');
          if (card) card.scrollIntoView({ block: 'nearest', inline: 'center' });
        }, options);
        reducedMotion.addEventListener('change', mode, options);
        mode();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        clearTimeout(this.resumeTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fanaze-editorial-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fanaze-ugc-player')) {
    customElements.define('fanaze-ugc-player', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.surface = this.querySelector('.fugc__surface');
        this.sound = this.querySelector('.fugc__sound');
        this.template = this.querySelector('template');
        if (!this.surface || !this.sound || !this.template) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches || navigator.connection?.saveData === true;
        this.inView = false;
        this.nearView = false;
        this.autoPauses = 0;
        this.surface.hidden = false;
        this.sound.hidden = false;
        this.setState(false);
        this.surface.addEventListener('click', () => {
          this.prepare();
          if (!this.video.paused) {
            this.userPaused = true;
            this.video.autoplay = false;
            this.video.pause();
          } else {
            this.userPaused = false;
            this.start();
          }
        }, options);
        this.sound.addEventListener('click', () => {
          this.prepare();
          this.video.muted = !this.video.muted;
          this.setSound();
          if (!this.video.muted) {
            this.userPaused = false;
            this.start();
          }
        }, options);
        this.addEventListener('ugc:active', () => {
          if (this.dataset.active === 'true' && this.nearView) this.prepare();
          this.syncPlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.userPaused = true;
            this.pauseAutomatically();
          }
        }, options);
        if ('IntersectionObserver' in window) {
          this.preloadObserver = new IntersectionObserver(([entry]) => {
            this.nearView = entry.isIntersecting;
            if (this.nearView && this.dataset.active === 'true') this.prepare();
          }, { rootMargin: '300px 0px' });
          this.preloadObserver.observe(this);
          this.playObserver = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting && entry.intersectionRatio > 0;
            if (this.inView && this.dataset.active === 'true') this.prepare();
            this.syncPlayback();
          }, { threshold: [0, .05] });
          this.playObserver.observe(this);
        } else {
          this.nearView = true;
          this.inView = true;
          if (this.dataset.active === 'true') this.prepare();
          this.syncPlayback();
        }
      }

      prepare() {
        if (this.video) return;
        this.video = this.template.content.querySelector('video').cloneNode(true);
        this.video.muted = true;
        const options = { signal: this.abort.signal };
        this.video.addEventListener('playing', () => {
          this.dataset.played = '';
          this.setState(true);
        }, options);
        this.video.addEventListener('pause', () => {
          if (this.autoPauses > 0) this.autoPauses -= 1;
          else if (this.video.paused) this.userPaused = true;
          this.setState(!this.video.paused);
        }, options);
        this.video.addEventListener('play', () => this.setState(true), options);
        this.video.addEventListener('volumechange', () => this.setSound(), options);
        this.video.addEventListener('error', () => this.setState(false), options);
        this.insertBefore(this.video, this.surface);
        this.setSound();
      }

      syncPlayback() {
        if (!this.video) return;
        if (this.dataset.active !== 'true' || !this.inView || document.hidden || this.userPaused) this.pauseAutomatically();
        else this.start();
      }

      start() {
        if (!this.video || this.dataset.active !== 'true' || !this.inView || document.hidden) return;
        this.video.autoplay = true;
        if (this.pending || !this.video.paused) return;
        const video = this.video;
        let retryPlayback = false;
        this.pending = true;
        video.play().then(() => {
          if (video !== this.video) return;
          if (!this.isConnected || this.dataset.active !== 'true' || !this.inView || document.hidden || this.userPaused) this.pauseAutomatically();
        }).catch(error => {
          if (video !== this.video) return;
          this.setState(false);
          retryPlayback = error.name === 'AbortError' && this.dataset.active === 'true' && this.inView && !document.hidden && !this.userPaused;
        }).finally(() => {
          if (video !== this.video) return;
          this.pending = false;
          if (retryPlayback) this.syncPlayback();
        });
      }

      pauseAutomatically() {
        if (!this.video) return;
        this.video.autoplay = false;
        if (!this.video.paused) {
          this.autoPauses += 1;
          this.video.pause();
        }
      }

      setState(playing) {
        this.dataset.state = playing ? 'playing' : 'paused';
        this.surface.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      }

      setSound() {
        this.dataset.muted = String(this.video.muted);
        const label = this.video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel;
        this.sound.setAttribute('aria-label', label);
        this.sound.setAttribute('aria-pressed', String(!this.video.muted));
        this.sound.title = label;
      }

      disconnectedCallback() {
        this.inView = false;
        this.preloadObserver?.disconnect();
        this.playObserver?.disconnect();
        this.abort?.abort();
        if (this.video) {
          this.video.pause();
          this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          this.video.removeAttribute('src');
          this.video.load();
          this.video.remove();
        }
        this.video = null;
        this.abort = null;
        this.pending = false;
        this.removeAttribute('data-played');
        this.dataset.muted = 'true';
      }
    });
  }

  if (!customElements.get('fanaze-ugc-carousel')) {
    customElements.define('fanaze-ugc-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.track = this.querySelector('.fugc__track');
        this.slides = [...this.querySelectorAll('[data-ugc-slide]')];
        if (!this.track || !this.slides.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous = this.querySelector('.fugc__previous');
        this.next = this.querySelector('.fugc__next');
        this.position = this.querySelector('.fugc__position');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = -1;
        const navigation = this.querySelector('.fugc__navigation');
        if (navigation) navigation.hidden = false;
        this.previous?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = this.index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = this.index + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.slides.length - 1;
          if (target !== undefined) {
            event.preventDefault();
            this.goTo(target);
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.contains(event.target));
          if (index >= 0) this.goTo(index);
        }, options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
          this.resizeObserver.observe(this.track);
        } else window.addEventListener('resize', () => this.scheduleUpdate(), options);
        this.update();
      }

      goTo(index) {
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        const track = this.track.getBoundingClientRect();
        const slide = this.slides[target].getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: rtl ? slide.right - track.right : slide.left - track.left, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const track = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const delta = Math.abs(rtl ? rect.right - track.right : rect.left - track.left);
          if (delta < distance) {
            distance = delta;
            nearest = index;
          }
        });
        if (nearest === this.index) return;
        this.index = nearest;
        this.slides.forEach((slide, index) => {
          const active = index === nearest;
          const player = slide.querySelector('fanaze-ugc-player');
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', String(!active));
          if (player) {
            player.dataset.active = String(active);
            player.dispatchEvent(new CustomEvent('ugc:active'));
          }
        });
        if (this.previous) this.previous.disabled = nearest === 0;
        if (this.next) this.next.disabled = nearest === this.slides.length - 1;
        if (this.position) this.position.textContent = `${String(nearest + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.abort = null;
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
